<template>
<div>
  <h1 class="text-center">فاکتور فروش</h1>
  <v-row>
    <v-col cols="12" sm="3" dir="rtl">
      <br><br>
      <h3 v-if="data.invoice" class="text-right">{{`تاریخ : ${data.invoice.create_date}`}}</h3>
      <br><br>
      <h3 v-if="data.invoice" class="text-right">{{`شماره فاکتور : ${data.invoice.id}`}}</h3>
    </v-col>
    <v-col cols="12" sm="7" dir="rtl"></v-col>
    <v-col cols="12" sm="2">
      <img :src="myLogo" :lazy-src="myLogo" height="100" width="70"/>
    </v-col>
  </v-row>

  <br><br>
  <v-row>
    <v-col cols="12" sm="4" dir="rtl">
    </v-col>
    <v-col cols="12" sm="3" dir="rtl">
      <h3 v-if="showBy">{{`توسط(خانم/آقای) : ${data.invoice.about || '-'}`}}</h3>
    </v-col>
    <v-col cols="12" sm="4" dir="rtl">
      <h3 v-if="showBuyer">{{`خریدار(خانم/آقای) : ${buyerName}`}}</h3>
    </v-col>
    <v-col cols="12" sm="1" dir="rtl">
    </v-col>
  </v-row>

  <br>
  <v-simple-table dense v-if="data.invoice">
    <thead>
      <tr>
        <td v-for="(col, index) in columns" :key="index">{{ col }}</td>
      </tr>
    </thead>
    <tbody>
      <!-- رندر آیتم‌های محصول‌دار -->
      <tr v-for="(item, i) in productItems" :key="item._id">
        <td class="text-center">{{ i + 1 }}</td>
        <td>{{ item.comment ? `${item.product_id.alias} - ${item.comment}` : item.product_id.alias }}</td>
        <td>{{ displayValue(item) }}</td>
        <td>{{ item.second_value ? item.product_id.unit2 : item.product_id.unit1 }}</td>
        <td>{{ item.price.toLocaleString() }}</td>
        <td>{{ displayTotal(item).toLocaleString() }}</td>
      </tr>

      <!-- جمع مبالغ -->
      <tr class="total">
        <td colspan="5" style="text-align: left">جمع مبالغ</td>
        <td colspan="2">{{ data.invoiceTotal | currencyDisplay }}</td>
      </tr>

      <!-- رندر آیتم‌های بدون محصول (تخفیف) -->
      <tr v-for="(item, i) in discountItems" :key="'discount-' + i">
        <td colspan="5" style="text-align: left">
          {{ item.price > 0 ? 'تخفیف(هزینه)' : item.price < 0 ? 'تخفیف(درامد)' : 'تخفیف' }}
        </td>
        <td colspan="2">{{ Math.abs(item.price) | currencyDisplay }}</td>
      </tr>

      <!-- مبلغ فاکتور -->
      <tr class="total">
        <td colspan="5" style="text-align: left">مبلغ فاکتور</td>
        <td colspan="3">{{ data.invoicePrice | currencyDisplay }}</td>
      </tr>
    </tbody>
  </v-simple-table>

  <br>
  <v-row>
    <v-col cols="12" sm="2" dir="rtl">
    </v-col>
    <v-col cols="12" sm="9" dir="rtl">
      <h5 class="text-right">*کلیه اقلام فاکتور تحویل خریدار شد*</h5>
    </v-col>
    <v-col cols="12" sm="1" dir="rtl">
      <h3 class="text-right">توضیحات : </h3>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="12" sm="4" dir="rtl">
      <br><br><br>
      <h3 class="text-right">امضای فروشنده</h3>
    </v-col>
    <v-col cols="12" sm="4" dir="rtl">
    </v-col>
    <v-col cols="12" sm="2">
      <br><br><br>
      <h3 class="text-right">امضای خریدار</h3>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "printInvoice",
  props: ['data'],
  data() {
    return {
      columns: ['ردیف', 'شرح کالا', 'مقدار', 'واحد', 'قیمت واحد(ریال)', 'مبلغ(ریال)'],
      myLogo: require('../../assets/Ghasemi Silver - Black (1).png'),
      // myLogo: require('../../assets/silver.jpeg'),
    };
  },
  computed: {
    productItems() {
      return this.data.invoice?.items.filter(item => item.product_id) || [];
    },
    discountItems() {
      return this.data.invoice?.items.filter(item => !item.product_id) || [];
    },
    showBy() {
      return this.data.invoice && ![1, 2, 3, 5].includes(this.data.invoice.person_id.id);
    },
    showBuyer() {
      return !!this.data.invoice;
    },
    buyerName() {
      if (!this.data.invoice) return '-';
      return ![1, 2, 5].includes(this.data.invoice.person_id.id) ?
        `${this.data.invoice.person_id.first_name} ${this.data.invoice.person_id.last_name || ''}` :
        this.data.invoice.about || '-';
    }
  },
  methods: {
    displayValue(item) {
      return item.second_value ?
        parseFloat(Math.abs(item.value / item.product_id.n).toFixed(4)) :
        parseFloat(Math.abs(item.value).toFixed(4));
    },
    displayTotal(item) {
      return item.second_value ?
        Math.round((Math.abs(item.value * item.price) / item.product_id.n) / 10) * 10 :
        Math.round(Math.abs(item.value * item.price) / 10) * 10;
    }
  }
};
</script>

<style lang="scss">
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
thead > tr > td {
    text-align: center;
    font-weight: 600;
}
</style>
